import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const register = (userData) => {
  return api.post('/register.php', userData);
};

export const login = (userData) => {
  return api.post('/login.php', userData);
};

export const updateUser = (userData) => {
  return api.put('/user.php', userData);
};

export const getCurrentUser = () => {
  return api.get('/user.php');
};

export const hasAcceptedAgreement = () => {
  return api.get('/agreement.php');
};

export const acceptAgreement = () => {
  return api.post('/agreement.php');
};

export const createPayment = (paymentData) => {
  return api.post('/payments.php', paymentData);
};

export const getUsers = () => {
  return api.get('/admin_users.php');
};

export const getAgreements = () => {
  return api.get('/admin_agreements.php');
};

export const getTelegramAdmins = () => {
  return api.get('/telegram_admins.php');
};

export const addTelegramAdmin = (telegram_id) => {
  return api.post('/telegram_admins.php', { telegram_id });
};

export const removeTelegramAdmin = (id) => {
  return api.delete('/telegram_admins.php', { data: { id } });
};
